__turbopack_context__.v({
  "appear-slide-left": "CtaFrame-module-scss-module__QngkTq__appear-slide-left",
  "bounceTwice": "CtaFrame-module-scss-module__QngkTq__bounceTwice",
  "container": "CtaFrame-module-scss-module__QngkTq__container",
  "ctaSection": "CtaFrame-module-scss-module__QngkTq__ctaSection",
  "fade-in-bottom": "CtaFrame-module-scss-module__QngkTq__fade-in-bottom",
  "fade-in-left": "CtaFrame-module-scss-module__QngkTq__fade-in-left",
  "fade-in-right": "CtaFrame-module-scss-module__QngkTq__fade-in-right",
  "fadeIn": "CtaFrame-module-scss-module__QngkTq__fadeIn",
  "loader": "CtaFrame-module-scss-module__QngkTq__loader",
  "puff-in-center": "CtaFrame-module-scss-module__QngkTq__puff-in-center",
  "puff-in-left": "CtaFrame-module-scss-module__QngkTq__puff-in-left",
  "pulse": "CtaFrame-module-scss-module__QngkTq__pulse",
  "pulse-contact": "CtaFrame-module-scss-module__QngkTq__pulse-contact",
  "shake-bottom": "CtaFrame-module-scss-module__QngkTq__shake-bottom",
  "slide-again": "CtaFrame-module-scss-module__QngkTq__slide-again",
  "slide-in-right": "CtaFrame-module-scss-module__QngkTq__slide-in-right",
  "stepContent-entrance": "CtaFrame-module-scss-module__QngkTq__stepContent-entrance",
});
